<div class="component-block">
  <kendo-loader *ngIf="isSaving" [type]="'infinite-spinner'" [loading]="isSaving"></kendo-loader>

  <h2>Profile Settings</h2>
  <form (ngSubmit)="saveProfile()">
    <div class="input-wrapper">
      <label for="firstName">First Name</label>
      <input id="firstName" kendoTextBox [(ngModel)]="contact.FirstName" name="FirstName" (ngModelChange)="onFieldChange()" />
    </div>
    <div class="input-wrapper">
      <label for="lastName">Last Name</label>
      <input id="lastName" kendoTextBox [(ngModel)]="contact.LastName" name="LastName" (ngModelChange)="onFieldChange()" />
    </div>
    <div class="input-wrapper">
      <label for="email">Email</label>
      <input id="email" kendoTextBox [(ngModel)]="contact.Email" name="Email" disabled />
    </div>
    <div class="input-wrapper">
      <label for="phone">Phone Number</label>
      <input id="phone" kendoTextBox [(ngModel)]="contact.Phone" name="Phone" (ngModelChange)="onFieldChange(); validatePhone()" />
      <span *ngIf="!isPhoneValid" class="error">Invalid phone number format.</span>
    </div>
    <div class="form-submit">
      <button kendoButton [disabled]="!hasChanges || !isPhoneValid" type="submit">Save</button>
    </div>
  </form>
</div>
